/**
 * Event-specific roles - соответствует бэкенду
 * Файл: C:\EventOS\new-backend-1.3\src\modules\auth\enums\event-roles.enum.ts
 */

export enum EventRole {
  ORGANIZER = 'organizer',
  CO_ORGANIZER = 'co_organizer',
  EVENT_ADMIN = 'event_admin',
  PARTICIPANT = 'participant',
  SPEAKER = 'speaker',
  SUPPLIER = 'supplier',
  EXECUTOR = 'executor'
}

export enum EventRoleCategory {
  MANAGEMENT = 'management',
  PARTICIPATION = 'participation',
  SERVICE = 'service'
}

export const EVENT_ROLE_CATEGORIES: Record<EventRole, EventRoleCategory> = {
  [EventRole.ORGANIZER]: EventRoleCategory.MANAGEMENT,
  [EventRole.CO_ORGANIZER]: EventRoleCategory.MANAGEMENT,
  [EventRole.EVENT_ADMIN]: EventRoleCategory.MANAGEMENT,
  [EventRole.PARTICIPANT]: EventRoleCategory.PARTICIPATION,
  [EventRole.SPEAKER]: EventRoleCategory.PARTICIPATION,
  [EventRole.SUPPLIER]: EventRoleCategory.SERVICE,
  [EventRole.EXECUTOR]: EventRoleCategory.SERVICE
};

/** Ключи подписей ролей мероприятия (AD-472); основание — см. INTERNAL_ROLE_LABEL_KEYS. */
export const EVENT_ROLE_LABEL_KEYS: Record<EventRole, string> = {
  [EventRole.ORGANIZER]: 'roles.event.organizer',
  [EventRole.CO_ORGANIZER]: 'roles.event.coOrganizer',
  [EventRole.EVENT_ADMIN]: 'roles.event.eventAdmin',
  [EventRole.PARTICIPANT]: 'roles.event.participant',
  [EventRole.SPEAKER]: 'roles.event.speaker',
  [EventRole.SUPPLIER]: 'roles.event.supplier',
  [EventRole.EXECUTOR]: 'roles.event.executor'
};

export const EVENT_ROLE_DESCRIPTIONS: Record<EventRole, string> = {
  [EventRole.ORGANIZER]: 'Организатор события',
  [EventRole.CO_ORGANIZER]: 'Совместный организатор',
  [EventRole.EVENT_ADMIN]: 'Администратор события',
  [EventRole.PARTICIPANT]: 'Участник события',
  [EventRole.SPEAKER]: 'Спикер события',
  [EventRole.SUPPLIER]: 'Поставщик услуг',
  [EventRole.EXECUTOR]: 'Исполнитель'
};
